enum AnswerOptionType {
  No = 0,
  Yes = 1,
  Neutral = 2,
  Multiple = 3,
}

export interface AnswerOptionsDto {
  id: string;
  tag: string;
  order: number;
  type: AnswerOptionType;
}

export enum QuestionType {
  SingleSelectYesNoQuestion = 1,
  SingleSelectYesNeutralNoQuestion = 2,
  MultipleSelect = 3,
}

export interface QuestionDto {
  id: string;
  tag: string;
  type: QuestionType;
  order: number;
  text: string;
  options: AnswerOptionsDto[];
  defaultSelection: string;
}

export interface GetQUestionsResponse {
  data: QuestionDto[];
  error: null; // TODO: CHECK WHAT OTHER TYPE THE ERROR COULD BE
  success: boolean;
  statusCode: string;
}

export enum ListSortDirection {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

export interface GetProductsParams {
  answers: string[];
  skip: number;
  take: number;
  sortDirection?: ListSortDirection;
  sortProperty?: string;
}

export interface ProductAttribute {
  tag: string;
  value: string | number;
  text: string;
  order: number;
}
